export default {
    inserted: function (el, binding) {
        const url = el.getAttribute('href');

        el.addEventListener('click', function(event) {
            event.preventDefault();
            window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=585,height=511');
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/share-button.js